export default __webpack_public_path__ + "static/media/educationIcon.ec56b5c0.jpg";